import React, { Component } from 'react';
import './Sections.css';
import ContentBlock from '../ContentBlock/ContentBlock';
import ContentBlockModal from '../ContentBlockModal/ContentBlockModal';
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Collapse,
  FormGroup,
  Input,
  Label
} from 'reactstrap';
import classnames from 'classnames';
import { IconPlus, IconMinus, IconRemove } from '../../Icons/Icons';
import update from 'react-addons-update';
import ContentSlider from '../ContentSlider/ContentSlider';
import scrollToElement from 'scroll-to-element';

const BlockWrapper = props => {
  if (props.swipeable) {
    return <ContentSlider size={props.size}>{props.children}</ContentSlider>;
  }

  return <React.Fragment>{props.children}</React.Fragment>;
};

class Sections extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sections: this.props.sections || [],
      openSections: [],
      modal: false,
      dndContext: {
        sectionIdx: -1,
        contentBlockIdx: -1
      },
      editContext: {
        sectionIdx: -1,
        contentBlockIdx: -1,
        contentBlock: null
      }
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.sections.length > prevProps.sections.length) {
      this.toggleSection(this.props.sections.length - 1);
      scrollToElement(`#sections`, {
        offset: 500,
        align: 'bottom',
        duration: 750
      });
    }
  }

  updateSections(e, sectionIndex) {
    let { value } = e.target;
    let inputId = e.target.id;
    if (e.target.type === 'checkbox') {
      value = e.target.checked;
    }

    const sections = this.props.sections;
    const newSections = update(sections, {
      [sectionIndex]: { [inputId]: { $set: value } }
    });

    this.props.updateSections(newSections);
  }

  rearrangeSections(moveFromIndex, moveToIndex) {
    const sections = this.props.sections;
    const currentSection = sections[moveFromIndex];
    let newSections = update(sections, {
      $splice: [[moveFromIndex, 1]]
    });

    newSections = update(newSections, {
      $splice: [[parseInt(moveToIndex, 10), 0, currentSection]]
    });

    this.props.updateSections(newSections);
  }

  toggleSection(index) {
    const openSections = this.state.openSections;
    const indexIsOpen = openSections.indexOf(index) > -1;
    let newopenSectionsArray = openSections;

    if (!indexIsOpen) {
      newopenSectionsArray[newopenSectionsArray.length] = index;
      this.setState({ openSections: newopenSectionsArray });
    } else {
      newopenSectionsArray.splice(openSections.indexOf(index), 1);
      this.setState({
        openSections: newopenSectionsArray
      });
    }
  }

  startDraggingContentBox(sectionIdx, contentBlockIdx, evt) {
    evt.dataTransfer.setData('text/plain', 'Dragging this');
    evt.dataTransfer.dropEffect = 'move';
    this.setState({
      dndContext: {
        sectionIdx,
        contentBlockIdx
      }
    });
  }

  draggingOverContentBox(ev) {
    ev.preventDefault();
    ev.currentTarget.classList.add('dropTo');
    ev.dataTransfer.dropEffect = 'move';
  }

  draggingOutContentBox(ev) {
    ev.currentTarget.classList.remove('dropTo');
  }

  dropToContentBox(sectionToIdx, contentBlockToIdx, ev) {
    ev.preventDefault();
    ev.currentTarget.classList.remove('dropTo');

    this.props.onMoveContentBlock(
      this.state.dndContext.sectionIdx,
      this.state.dndContext.contentBlockIdx,
      sectionToIdx,
      contentBlockToIdx
    );
    this.setState({
      dndContext: {
        sectionIdx: -1,
        contentBlockIdx: -1
      }
    });
  }

  toggleEditing(editing, sectionIndex, contentBlockIndex, contentBlock) {
    this.setState({
      editContext: {
        contentBlock: editing ? contentBlock : null,
        sectionIdx: editing ? sectionIndex : -1,
        contentBlockIdx: editing ? contentBlockIndex : -1
      },
      modal: editing
    });
  }

  render() {
    const {
      imageBasePath,
      removeSection,
      removeContentBlock,
      sections
    } = this.props;
    const { openSections, modal } = this.state;

    return (
      <div className="sections" id="sections">
        {sections.map((section, sectionIndex) => {
          return (
            <Card key={sectionIndex}>
              <CardHeader
                className={classnames({
                  open: openSections.indexOf(sectionIndex) > -1
                })}
              >
                <h5
                  className="toggle"
                  onClick={() => this.toggleSection(sectionIndex)}
                >
                  <IconPlus />
                  <IconMinus />
                  <span>Section</span>
                  {section.contentBlocks.length > 0 && (
                    <small>
                      (
                      {section.contentBlocks.map((contentBlock, index) => {
                        if (index > 0) {
                          return (
                            <React.Fragment key={index}>
                              , {contentBlock.type}
                            </React.Fragment>
                          );
                        }
                        return (
                          <React.Fragment key={index}>
                            {contentBlock.type}
                          </React.Fragment>
                        );
                      })}
                      )
                    </small>
                  )}
                </h5>
                <div>
                  <FormGroup inline check>
                    <Label check title="Remove bottom margins from content">
                      <Input
                        title="Remove bottom margins from content"
                        onChange={e => this.updateSections(e, sectionIndex)}
                        id="noMargins"
                        type="checkbox"
                        checked={section.noMargins || false}
                      />
                      No margin
                    </Label>
                  </FormGroup>
                  <FormGroup inline check>
                    <Label check title="Make section a carousel slider">
                      <Input
                        title="Make section a carousel slider"
                        onChange={e => this.updateSections(e, sectionIndex)}
                        id="swipeable"
                        type="checkbox"
                        checked={section.swipeable || false}
                      />
                      Slider
                    </Label>
                  </FormGroup>
                  <FormGroup inline>
                    <Input
                      title="Change number of items per row"
                      type="select"
                      id="size"
                      bsSize="sm"
                      onChange={e => this.updateSections(e, sectionIndex)}
                      value={section.size || ''}
                    >
                      <option value="one-wide" defaultValue>
                        One wide
                      </option>
                      <option value="two-wide">Two wide</option>
                      <option value="three-wide">Three wide</option>
                      <option value="four-wide">Four wide</option>
                      <option value="five-wide">Five wide</option>
                    </Input>
                  </FormGroup>
                  <FormGroup inline>
                    <Input
                      title="Change section order"
                      type="select"
                      id="order"
                      bsSize="sm"
                      onChange={e =>
                        this.rearrangeSections(sectionIndex, e.target.value)
                      }
                      value={sectionIndex || ''}
                    >
                      {sections.map((section, index) => (
                        <option key={index} value={index}>
                          {index + 1}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                  <Button
                    color="primary"
                    onClick={() => removeSection(sectionIndex)}
                    size="sm"
                    outline
                    title="Remove section"
                  >
                    <IconRemove />
                  </Button>
                </div>
              </CardHeader>
              <CardBody>
                <Collapse isOpen={openSections.indexOf(sectionIndex) > -1}>
                  <div className="text-center pt-3">
                    <Button
                      outline
                      color="primary"
                      onClick={() =>
                        this.toggleEditing(true, sectionIndex, -1, null)
                      }
                    >
                      <IconPlus />
                      <span>Add content block</span>
                    </Button>
                    <hr />
                  </div>
                  {section.contentBlocks.length > 0 && (
                    <div
                      className={`section ${section.size} ${
                        section.swipeable ? 'swipeable' : ''
                      } ${section.noMargins ? 'no-margins' : ''}`}
                    >
                      <BlockWrapper
                        swipeable={section.swipeable}
                        size={section.size}
                      >
                        {section.contentBlocks.map((content, index) => {
                          const draggableProps = {
                            draggable: true,
                            className: 'draggable',
                            onDragStart: evt => {
                              this.startDraggingContentBox(
                                sectionIndex,
                                index,
                                evt
                              );
                            },
                            onDragOver: evt => {
                              this.draggingOverContentBox(evt);
                            },
                            onDragLeave: evt => {
                              this.draggingOutContentBox(evt);
                            },
                            onDrop: evt => {
                              this.dropToContentBox(sectionIndex, index, evt);
                            }
                          };
                          return (
                            <div key={index}>
                              <div {...draggableProps}>
                                <ContentBlock
                                  imageBasePath={imageBasePath}
                                  {...content}
                                  sectionIndex={sectionIndex}
                                  contentBlockIndex={index}
                                  removeContentBlock={removeContentBlock}
                                  onToggleEditing={editing => {
                                    this.toggleEditing(
                                      editing,
                                      sectionIndex,
                                      index,
                                      content
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          );
                        })}
                      </BlockWrapper>
                    </div>
                  )}
                </Collapse>
              </CardBody>
            </Card>
          );
        })}

        <div className="text-right mb-2 mt-4">
          <Button
            outline
            color="primary"
            onClick={() => this.props.addSection(sections)}
          >
            <IconPlus />
            <span>Add section</span>
          </Button>
        </div>

        <ContentBlockModal
          isOpen={modal}
          onClose={() => this.toggleEditing(false, -1)}
          type={Boolean(this.state.editContext.contentBlock) ? 'edit' : 'add'}
          contentBlock={this.state.editContext.contentBlock}
          imageBasePath={imageBasePath}
          sectionIndex={this.state.editContext.sectionIdx}
          contentBlockIndex={this.state.editContext.contentBlockIdx}
          className={'content-block-modal'}
        />
      </div>
    );
  }
}

export default Sections;



// WEBPACK FOOTER //
// ./src/components/landingPage/Sections/Sections.js